import Swiper, { Lazy, Autoplay, Navigation, Pagination } from 'swiper';


export default class Home {

	constructor () {
		this.init();
	}

	init () {
		if(document.querySelectorAll('#home-projects')) {
			Swiper.use([Navigation, Pagination, Lazy]);
			new Swiper('#home-projects', {
				slidesPerView: 1,
				slidesPerColumn: 1,
				slidesPerGroup: 1,
				preloadImages: false,
				spaceBetween: 0,
				loop: true,
				autoplay: {
					delay: 3000,
				},
				pagination: {
					el: '#home-projects .swiper-pagination',
					clickable: true
				},
        navigation: {
				  nextEl: '.project-next',
				  prevEl: '.project-prev'
        },
				lazy: {
					loadPrevNext: false,
					loadOnTransitionStart: true,
				},
				on: {
				  init: function (swiper) {
				  }
				}
			  });
		}
	}
}
